{
  "LABEL_MGMT": {
    "HEADER": "ラベル",
    "HEADER_BTN_TXT": "ラベルを追加",
    "LOADING": "ラベルを取得中",
    "DESCRIPTION": "ラベルは会話やリードを分類し、優先順位をつけるのに役立ちます。サイドパネルを使用して会話や連絡先にラベルを割り当てることができます。",
    "LEARN_MORE": "ラベルについて詳しく知る",
    "COUNT": "{n} label | {n} labels",
    "SEARCH_PLACEHOLDER": "ラベルを検索...",
    "NO_RESULTS": "No labels found matching your search",
    "SEARCH_404": "検索内容（クエリ）に一致する項目はありませんでした",
    "LIST": {
      "404": "このアカウントには利用可能なラベルがありません。",
      "TITLE": "ラベルの管理",
      "DESC": "ラベルを使用すると、会話をグループ化できます。",
      "TABLE_HEADER": {
        "NAME": "名前",
        "DESCRIPTION": "説明",
        "COLOR": "色",
        "ACTION": "操作"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "ラベル名",
        "PLACEHOLDER": "ラベル名",
        "REQUIRED_ERROR": "ラベル名は必須です",
        "MINIMUM_LENGTH_ERROR": "最小2文字が必要です",
        "VALID_ERROR": "アルファベット、数字、ハイフン、アンダースコアのみ使用可能です"
      },
      "DESCRIPTION": {
        "LABEL": "説明",
        "PLACEHOLDER": "ラベルの説明"
      },
      "COLOR": {
        "LABEL": "色"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "サイドバーにラベルを表示"
      },
      "EDIT": "編集",
      "CREATE": "作成",
      "DELETE": "削除",
      "CANCEL": "キャンセル"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "会話にラベルを追加",
        "MULTIPLE_SUGGESTION": "このラベルを選択",
        "DESELECT": "ラベルの選択を解除",
        "DISMISS": "提案を無視"
      },
      "POWERED_BY": "Chatwoot AI",
      "DISMISS": "提案を無視",
      "ADD_SELECTED_LABELS": "選択したラベルを追加",
      "ADD_SELECTED_LABEL": "選択したラベルを追加",
      "ADD_ALL_LABELS": "すべてのラベルを追加",
      "SUGGESTED_LABELS": "提案されたラベル"
    },
    "ADD": {
      "TITLE": "ラベルを追加",
      "DESC": "ラベルを使用すると、会話をグループ化できます。",
      "API": {
        "SUCCESS_MESSAGE": "ラベルの追加に成功しました",
        "ERROR_MESSAGE": "エラーが発生しました。もう一度お試しください。"
      }
    },
    "EDIT": {
      "TITLE": "ラベルを編集",
      "API": {
        "SUCCESS_MESSAGE": "ラベルが正常に更新されました",
        "ERROR_MESSAGE": "エラーが発生しました。もう一度お試しください。"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "削除",
      "API": {
        "SUCCESS_MESSAGE": "ラベルの削除に成功しました",
        "ERROR_MESSAGE": "エラーが発生しました。もう一度お試しください。"
      },
      "CONFIRM": {
        "TITLE": "削除の確認",
        "MESSAGE": "削除してもよろしいですか？ ",
        "YES": "削除する ",
        "NO": "いいえ "
      }
    }
  }
}
